<template>
  <v-row justify="center">
    <v-dialog
      v-model="$store.state.progressDisplay"
      persistent
      max-width="300"
      overlay-color="grey darken-3"
      overlay-opacity="0.8"
    >
      <v-card color="primary" dark>
        <v-card-text>
          잠시만 기다려 주세요.
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {};
</script>
